/* eslint-disable func-names */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable camelcase */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import $ from 'jquery'

const page = document.body.getAttribute('data-layer-page');

function initDataLayer() {
  window.dataLayer = window.dataLayer || [];
}

function handleLink(event, click_category, click_action, click_label, isExternal, e) {
  const link = e.currentTarget.href
  let redirected = false
  if ( !window.google_tag_manager ) return
  e.preventDefault()
  window.dataLayer.push({
    event,
    click_category,
    click_action,
    click_label,
    click_url: link,
    eventCallback: () => {
      if (redirected) return
      if (isExternal) {
        const newWindow = window.open();
        newWindow.opener = null;
        newWindow.location = link;
      } else {
        window.location = link;
      }
      redirected = true
    },
    eventTimeout: 2000,
  })
}

function initHomePageLayer() {
  if (page !== 'home') return

  const featureButton = document.querySelector('#feature-button')
  const userAvatar = document.querySelector('#user-avatar')

  featureButton && featureButton.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res header', 'Link click', 'Book Your Room', false, e)
  })

  userAvatar && userAvatar.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res header', 'Link click', 'User Avatar', true, e)
  })
}

function initBookYourRoomLayer() {
  if (page !== 'book-your-room') return

  const viewYourRoomOptions = document.querySelector('.dl-view-your-room-options a')
  const standardRoom = document.querySelector('.dl-standard-room')
  const standardRoomPlus = document.querySelector('.dl-standard-room-plus')
  const superiorRoom = document.querySelector('.dl-superior-room')
  const accessibleRoom = document.querySelector('.dl-accessible-room')

  viewYourRoomOptions && viewYourRoomOptions.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res hero banner', 'Link click', 'View your room options', false, e)
  })

  standardRoom && standardRoom.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res room tile', 'Link click', 'Standard', false, e)
  })

  standardRoomPlus && standardRoomPlus.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res room tile', 'Link click', 'Standard Plus', false, e)
  })

  superiorRoom && superiorRoom.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res room tile', 'Link click', 'Superior', false, e)
  })

  accessibleRoom && accessibleRoom.addEventListener('click', (e) => {
    handleLink('Custom click', 'UQ Res room tile', 'Link click', 'Accessible', false, e)
  })
}

function initAddonLayer() {
  if (page !== 'room-page') return
  const roomAddons = document.querySelectorAll('.room-addon');

  [...roomAddons].forEach((location) => {
    const button = location.querySelector('.wp-block-button__link')

    button && button.addEventListener('click', (e) => {
      window.dataLayer.push({
        event: 'Custom click',
        click_category: 'UQ Res add on',
        click_action: e.target.innerText === '- REMOVE' ? 'Add' : 'Remove',
        click_label: location.querySelector('.room-addon-title').innerText,
      })
    })
  })
}

function initBookingFormLayer() {
  if (page !== 'room-page') return
  const backButton = document.querySelector('#star-form-button-back')

  $('#check-in').on('select2:select', function () {
    window.dataLayer.push({
      event: 'Custom click',
      click_category: 'UQ Res booking widget',
      click_action: 'Select item',
      click_label: $.trim($(this).find(':selected').text()),
    })
  })

  backButton && backButton.addEventListener('click', () => {
    window.dataLayer.push({
      event: 'Custom click',
      click_category: 'UQ Res booking widget',
      click_action: 'Link Click',
      click_label: 'Back',
    })
  })
}

function initFormConfirmationPageLayer() {
  if (page !== 'thank-you-contact-us' && page !== 'thank-you-waitlist') return
  const params = new URLSearchParams(window.location.search)
  if (!params.has('form')) return
  const formName = params.get('form')

  window.dataLayer.push({
    event: 'Custom click',
    click_category: formName === 'Contact Us' ? 'UQ Res Contact us' : 'UQ Res Join the waitlist',
    click_action: `Form name=${formName},Position=right`,
    click_label: 'Back',
    click_url: undefined,
  })
}

function init() {
  if ( !page ) return

  initDataLayer()
  initHomePageLayer()
  initBookYourRoomLayer()
  initAddonLayer()
  initBookingFormLayer()
  initFormConfirmationPageLayer()
}

export default {
  init,
};
